module.exports = __webpack_public_path__ + "static/media/18.202b0ffa.png";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/BidderSources/components/Table/components/Row/18.png
// module id = 1366
// module chunks = 0